import { apiResponseType } from ".";

import { apiAuth } from ".";

export interface SalesProps {
  unity_id: number;
  client_id: number | null;
  seller_id: string | number;
  lead_id?: number | null;
  sale_type_id: number;
  is_pre_sale?: boolean;
  address?: {
    addressName: string;
    street: string;
    number: string;
    complement?: string;
    neighborhood?: string;
    city?: string;
    state?: string;
    zip_code?: string;
    latitude?: any;
    longitude?: any;
  };
  circuit_route_id?: string;
  tracking_code?: string;
  payment_forms: PaymentFormItem[];
  contest_product_classifications: ContestProductClassification[];
}

export interface PaymentFormItem {
  payment_form_id: number;
  value: number;
  bank_account_id?: string;
}

export interface ContestProductClassification {
  id: number;
  quantity: number;
}

export enum STATUS_SALE {
  AGUARDANDO_PAGAMENTO = 1,
  PAGAMENTO_APROVADO = 2,
  PAGAMENTO_RECUSADO = 3,
  EM_SEPARACAO = 4,
  EM_TRANSPORTE = 5,
  ENTREGUE = 6,
  CANCELADO = 7,
}

export interface SalesFiltersParams {
  sale_id?: string;
  seller_id?: number | string[];
  unity_id?: string | string[];
  client_id?: string;
  client_name?: string;
  sale_type_id?: string;
  payment_form_id?: string | string[];
  lottery_id?: string | string[];
  contest_id?: string | string[];
  client_origin_id?: string | string[];
  process_step_sale_id?: string;
  bank_account_id?: string;
  sale_status_id?: string | string[];
  start_date?: string;
  end_date?: string;
  start_time?: string;
  end_time?: string;
  order_by?: string;
  order_direction?: string;
  status?: string;
  per_page?: number;
  product_classification_id?: string | string[];
  product_name?: string;
  min_total?: number;
  max_total?: number;
  is_new_client?: string;
}

const appendArrayParam = (queryParams: URLSearchParams, key: string, values?: string | string[]) => {
  if (!values) return;
  if (Array.isArray(values)) {
    values.forEach(v => {
      if (v && v !== "all") queryParams.append(`${key}[]`, v);
    });
  } else if (values !== "all") {
    queryParams.append(key, values);
  }
};

export const getSales = (
  page: number = 1,
  params?: SalesFiltersParams
) => {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page.toString());

  if (params?.sale_id)
    queryParams.append("sale_id", params.sale_id);
  if (params?.seller_id) {
    if (Array.isArray(params.seller_id)) {
      params.seller_id.forEach(v => {
        if (v && v !== "all") queryParams.append("seller_id[]", v);
      });
    } else {
      queryParams.append("seller_id", params.seller_id.toString());
    }
  }
  appendArrayParam(queryParams, "unity_id", params?.unity_id);
  if (params?.client_id && params.client_id !== "all")
    queryParams.append("client_id", params.client_id);
  if (params?.client_name)
    queryParams.append("client_name", params.client_name);
  if (params?.sale_type_id && params.sale_type_id !== "all")
    queryParams.append("sale_type_id", params.sale_type_id);
  appendArrayParam(queryParams, "payment_form_id", params?.payment_form_id);
  appendArrayParam(queryParams, "lottery_id", params?.lottery_id);
  appendArrayParam(queryParams, "contest_id", params?.contest_id);
  appendArrayParam(queryParams, "client_origin_id", params?.client_origin_id);
  if (params?.process_step_sale_id && params.process_step_sale_id !== "all")
    queryParams.append("process_step_sale_id", params.process_step_sale_id);
  if (params?.bank_account_id && params.bank_account_id !== "all")
    queryParams.append("bank_account_id", params.bank_account_id);
  appendArrayParam(queryParams, "sale_status_id", params?.sale_status_id);
  if (params?.start_date)
    queryParams.append("start_date", params.start_date);
  if (params?.end_date)
    queryParams.append("end_date", params.end_date);
  if (params?.start_time)
    queryParams.append("start_time", params.start_time);
  if (params?.end_time)
    queryParams.append("end_time", params.end_time);
  if (params?.order_by)
    queryParams.append("order_by", params.order_by);
  if (params?.order_direction)
    queryParams.append("order_direction", params.order_direction);
  if (params?.status)
    queryParams.append("status", params.status);
  if (params?.per_page)
    queryParams.append("per_page", params.per_page.toString());
  appendArrayParam(queryParams, "product_classification_id", params?.product_classification_id);
  if (params?.product_name)
    queryParams.append("product_name", params.product_name);
  if (params?.min_total !== undefined && params.min_total > 0)
    queryParams.append("min_total", params.min_total.toString());
  if (params?.max_total !== undefined && params.max_total > 0)
    queryParams.append("max_total", params.max_total.toString());
  if (params?.is_new_client && params.is_new_client !== "all")
    queryParams.append("is_new_client", params.is_new_client);

  return apiAuth.get(`/sales?${queryParams.toString()}`) as apiResponseType;
};

export const selectProducts = (seller_id?: string) =>
  apiAuth.get(`/distributions/sellers/all/select`, {
    params: {
      seller_id: seller_id || "",
    },
  }) as apiResponseType;

export const createSale = (data: SalesProps) =>
  apiAuth.post("/sales/store", data) as apiResponseType;

export const getPaymentForms = () =>
  apiAuth.get("/payment-forms/select") as apiResponseType;

export const getPaymentFormsForSale = () =>
  apiAuth.get("/payment-forms/select-for-sale") as apiResponseType;

export const updateSales = (uuid: string, status_id: STATUS_SALE) =>
  apiAuth.put(`/sales/${uuid}/update-status`, {
    sale_status_id: status_id,
  }) as apiResponseType;

export const registerHasAprovedPayment = ({
  id,
  itsAproved,
  sale_code_transaction,
  tracking_code,
}: {
  id: string;
  itsAproved: boolean;
  sale_code_transaction?: any;
  tracking_code?: string;
}) =>
  apiAuth.post(`/sales/${id}/finalize-sale`, {
    payment_approved: itsAproved,
    sale_code_transaction: sale_code_transaction || null,
    tracking_code: tracking_code || null,
  }) as apiResponseType;

export const updateSaleStatus = (
  process_step_sale_id: number,
  process_status_id: STATUS_SALE,
  tracking_code?: string
) =>
  apiAuth.put(`/sales/process-step/update-status`, {
    process_step_sale_id,
    process_status_id,
    tracking_code: tracking_code || null,
  }) as apiResponseType;

export const addMessageToProcessStepSale = (payload: {
  process_step_sale_id: number;
  text: string;
  file?: File;
}) =>
  apiAuth.postForm(
    `/sales/process-step/chat/store`,
    payload
  ) as apiResponseType;

export const checkPaymentStatus = (sale_id: string) =>
  apiAuth.get(`/sales/check-payment-status/${sale_id}`) as apiResponseType;

// Apuração de vendas
export const getInvestigationSales = (page = 1, params: { contest_status_id?: number; contest_id?: number } = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("page", page.toString());

  const contestStatusId = params.contest_status_id || 1;
  queryParams.append("contest_status_id", contestStatusId.toString());

  if (params.contest_id) {
    queryParams.append("contest_id", params.contest_id.toString());
  }

  return apiAuth.get(`/contests/investigation-sales?${queryParams.toString()}`) as apiResponseType;
};

export const showInvestigationSale = (uuid: string) =>
  apiAuth.get(`/contests/investigation-sales/${uuid}/show`) as apiResponseType;

export interface UpdateInvestigationSaleProps {
  investigation_price_per_share: number;
  investigation_price_total: number;
  receive_by_cashier: boolean;
  non_winning_ticket: boolean;
}

export interface InvestigationSalesGrouped {
  contest_id: number;
  contest_uuid: string;
  contest_name: string;
  contest_status_id: number;
  contest_status_name: string;
  validation_date: string;
  lottery_id: number;
  lottery_name: string;
  lottery_color: string;
  total_products: number;
  total_apurados: number;
  total_investigated: number;
  total_prize_paid: number;
  last_investigation_date: string | null;
  last_author_name: string | null;
}

export const updateInvestigationSale = (
  uuid: string,
  data: UpdateInvestigationSaleProps
) =>
  apiAuth.put(
    `/contests/investigation-sales/${uuid}/update`,
    data
  ) as apiResponseType;

export interface BulkUpdateInvestigationSaleItem {
  uuid: string;
  investigation_price_per_share: number;
  investigation_price_total: number;
  receive_by_cashier: boolean;
  non_winning_ticket: boolean;
}

export const bulkUpdateInvestigationSales = (
  investigations: BulkUpdateInvestigationSaleItem[]
) =>
  apiAuth.put(
    `/contests/investigation-sales/bulk-update`,
    { investigations }
  ) as apiResponseType;

export const getSalesByClient = (params?: {
  client_name?: string;
  client_phone?: string;
  client_email?: string;
  uuid?: string;
  seller_id?: string;
  page?: number;
  start_date?: string;
  end_date?: string;
  sale_type_id?: string;
  exclude_cancelled?: boolean;
  sale_status_id?: string | string[];
  unity_id?: string;
  min_total?: string;
  max_total?: string;
}) => {
  const queryParams = new URLSearchParams();

  if (params?.client_name)
    queryParams.append("client_name", params.client_name);
  if (params?.client_phone)
    queryParams.append("client_phone", params.client_phone);
  if (params?.client_email)
    queryParams.append("client_email", params.client_email);
  if (params?.seller_id)
    queryParams.append("seller_id", params.seller_id);
  if (params?.page)
    queryParams.append("page", params.page.toString());
  if (params?.start_date)
    queryParams.append("start_date", params.start_date);
  if (params?.end_date)
    queryParams.append("end_date", params.end_date);
  if (params?.sale_type_id && params.sale_type_id !== "all")
    queryParams.append("sale_type_id", params.sale_type_id);
  if (params?.exclude_cancelled)
    queryParams.append("exclude_cancelled", "1");
  if (params?.sale_status_id) {
    if (Array.isArray(params.sale_status_id)) {
      params.sale_status_id.forEach(id => {
        if (id && id !== "all") queryParams.append("sale_status_id[]", id);
      });
    } else if (params.sale_status_id !== "all") {
      queryParams.append("sale_status_id", params.sale_status_id);
    }
  }
  if (params?.unity_id && params.unity_id !== "all")
    queryParams.append("unity_id", params.unity_id);
  if (params?.min_total)
    queryParams.append("min_total", params.min_total);
  if (params?.max_total)
    queryParams.append("max_total", params.max_total);

  return apiAuth.get(
    `clients/all-sales?${queryParams.toString()}`
  ) as apiResponseType;
};

export interface UpdateSaleParams {
  sale_type_id?: number;
  bank_account_id?: number | null;
  circuit_route_id?: number | null;
  sale_status_id?: number;
  tracking_code?: string;
  address?: {
    addressName: string;
    street: string;
    number: string;
    complement: string;
    neighborhood: string;
    city: string;
    state: string;
    zip_code: string;
    latitude: number | null;
    longitude: number | null;
  };
  payment_forms?: Array<{
    payment_form_id: number;
    value: number;
    installments?: number | null;
  }>;
}

export const updateSale = (uuid: string, data: UpdateSaleParams) =>
  apiAuth.put(`/sales/${uuid}/update-sale`, data) as apiResponseType;

export const deleteSale = (uuid: string) =>
  apiAuth.delete(`/sales/${uuid}/destroy`) as apiResponseType;

export const publicShowSale = (uuid: string) =>
  apiAuth.get(`/sales/public/${uuid}/show`) as apiResponseType;

export const publicCheckPaymentStatus = (saleId: string) =>
  apiAuth.get(`/sales/public/check-payment-status/${saleId}`) as apiResponseType;

export interface SalesHistoricSellersParams {
  start_date?: string;
  end_date?: string;
  seller_id?: string[];
  sale_status_id?: string[];
}

export const getSalesHistoricSellers = (params?: SalesHistoricSellersParams) => {
  const queryParams = new URLSearchParams();

  if (params?.start_date)
    queryParams.append("start_date", params.start_date);
  if (params?.end_date)
    queryParams.append("end_date", params.end_date);

  if (params?.seller_id && params.seller_id.length > 0) {
    params.seller_id.forEach(id => {
      queryParams.append("seller_id[]", id);
    });
  }

  if (params?.sale_status_id && params.sale_status_id.length > 0) {
    params.sale_status_id.forEach(id => {
      queryParams.append("status_id[]", id);
    });
  }

  return apiAuth.get(`/sales/historic-sellers?${queryParams.toString()}`) as apiResponseType;
};

// Exportar vendas
export const regeneratePix = (uuid: string) =>
  apiAuth.post(`/sales/${uuid}/regenerate-pix`) as apiResponseType;

export const exportSales = (params?: SalesFiltersParams, format: 'xlsx' | 'csv' = 'xlsx') => {
  const queryParams = new URLSearchParams();

  queryParams.append("format", format);

  if (params?.seller_id) {
    if (Array.isArray(params.seller_id)) {
      params.seller_id.forEach(v => {
        if (v && v !== "all") queryParams.append("seller_id[]", v);
      });
    } else {
      queryParams.append("seller_id", params.seller_id.toString());
    }
  }
  appendArrayParam(queryParams, "unity_id", params?.unity_id);
  if (params?.client_id && params.client_id !== "all")
    queryParams.append("client_id", params.client_id);
  if (params?.client_name)
    queryParams.append("client_name", params.client_name);
  if (params?.sale_type_id && params.sale_type_id !== "all")
    queryParams.append("sale_type_id", params.sale_type_id);
  appendArrayParam(queryParams, "payment_form_id", params?.payment_form_id);
  appendArrayParam(queryParams, "lottery_id", params?.lottery_id);
  appendArrayParam(queryParams, "contest_id", params?.contest_id);
  appendArrayParam(queryParams, "client_origin_id", params?.client_origin_id);
  appendArrayParam(queryParams, "sale_status_id", params?.sale_status_id);
  if (params?.start_date)
    queryParams.append("start_date", params.start_date);
  if (params?.end_date)
    queryParams.append("end_date", params.end_date);
  appendArrayParam(queryParams, "product_classification_id", params?.product_classification_id);
  if (params?.product_name)
    queryParams.append("product_name", params.product_name);
  if (params?.min_total !== undefined && params.min_total > 0)
    queryParams.append("min_total", params.min_total.toString());
  if (params?.max_total !== undefined && params.max_total > 0)
    queryParams.append("max_total", params.max_total.toString());
  if (params?.is_new_client && params.is_new_client !== "all")
    queryParams.append("is_new_client", params.is_new_client);

  return apiAuth.get(`/sales/export?${queryParams.toString()}`, {
    responseType: 'blob'
  });
};
